import React from "react";
import "./SvgIcons.scss"

import { ReactComponent as SourceInboxIcon } from "../../assets/images/menu/inbox.svg";
import { ReactComponent as SourceMyCardIcon } from "../../assets/images/menu/my-card.svg";
import { ReactComponent as SourcePointsIcon } from "../../assets/images/points.svg";
import { ReactComponent as SourceCashDollarIcon } from "../../assets/images/cash-dollar.svg";

import { ReactComponent as SourceHomeIcon } from '../../assets/images/home.svg';
import { ReactComponent as SourceOfferIcon } from '../../assets/images/offer.svg';
import { ReactComponent as SourceCartIcon } from '../../assets/images/cart.svg';
import { ReactComponent as SourceLocationIcon } from '../../assets/images/location.svg';
import { ReactComponent as SourceMyProfileIcon } from '../../assets/images/menu/my-profile.svg';

import { ReactComponent as SourceTicketIcon } from 'assets/images/ticket-icon.svg';
import { ReactComponent as SourceCouponIcon } from 'assets/images/coupon-icon.svg';
import { ReactComponent as SourceRightArrow } from 'assets/images/right-arrow.svg';
import { ReactComponent as SourceActivityLogIcon } from 'assets/images/menu/activity-log.svg';
import { ReactComponent as SourceAboutIcon } from 'assets/images/menu/about.svg';
import { ReactComponent as SourceLanguageIcon } from 'assets/images/language.svg';
import { ReactComponent as SourceTransactionHistoryIcon } from 'assets/images/menu/transaction-history.svg';
import { ReactComponent as SourceRewardStatusIcon } from 'assets/images/menu/reward-status.svg';
import { ReactComponent as SourceTickIcon } from 'assets/images/tick.svg';
import { ReactComponent as SourceInfoIcon } from 'assets/images/Info.svg';

export const InboxIcon = ({ className, ...props }) =>
  <SourceInboxIcon className={`inbox-icon ${className || ""}`} {...props} />

export const MyCardIcon = ({ className, ...props }) =>
  <SourceMyCardIcon className={`my-card-icon ${className || ""}`} {...props} />

export const PointsIcon = ({ className, ...props }) =>
  <SourcePointsIcon className={`points-icon ${className || ""}`} {...props} />

export const CashDollarIcon = ({ className, ...props }) =>
  <SourceCashDollarIcon className={`cash-dollar-icon ${className || ""}`} {...props} />

export const HomeIcon = ({ className, ...props }) =>
  <SourceHomeIcon className={`nav-home-icon ${className || ""}`} {...props} />

export const OfferIcon = ({ className, ...props }) =>
  <SourceOfferIcon className={`nav-offer-icon ${className || ""}`} {...props} />

export const CartIcon = ({ className, ...props }) =>
  <SourceCartIcon className={`nav-cart-icon ${className || ""}`} {...props} />

export const LocationIcon = ({ className, ...props }) =>
  <SourceLocationIcon className={`nav-location-icon ${className || ""}`} {...props} />

export const MyProfileIcon = ({ className, ...props }) =>
  <SourceMyProfileIcon className={`my-profile-icon ${className || ""}`} {...props} />

export const TicketIcon = ({ className, ...props }) =>
  <SourceTicketIcon className={`ticket-icon ${className || ""}`} {...props} />

export const CouponIcon = ({ className, ...props }) =>
  <SourceCouponIcon className={`coupons-icon ${className || ""}`} {...props} />

export const RightArrow = ({ className, ...props }) =>
  <SourceRightArrow className={`right-arrow-icon ${className || ""}`} {...props} />

export const ActivityLogIcon = ({ className, ...props }) =>
  <SourceActivityLogIcon className={`activity-log-icon ${className || ""}`} {...props} />

export const AboutIcon = ({ className, ...props }) =>
  <SourceAboutIcon className={`about-icon ${className || ""}`} {...props} />

export const LanguageIcon = ({ className, ...props }) =>
  <SourceLanguageIcon className={`language-icon ${className || ""}`} {...props} />

export const TransactionHistoryIcon = ({ className, ...props }) =>
  <SourceTransactionHistoryIcon className={`transaction-history-icon ${className || ""}`} {...props} />

export const RewardStatusIcon = ({ className, ...props }) =>
  <SourceRewardStatusIcon className={`reward-status-icon ${className || ""}`} {...props} />

export const TickIcon = ({ className, ...props }) =>
  <SourceTickIcon className={`tick-icon ${className || ""}`} {...props} />

export const InfoIcon = ({ className, ...props }) =>
  <SourceInfoIcon className={`info-icon ${className || ""}`} {...props} />
